import React from 'react';
import Layout from '../components/Layout';

const CookiePolicy: React.FC = () => {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Politique de Cookies',
    description:
      'Politique de cookies de Primorixx. Découvrez comment nous utilisons les cookies et technologies similaires sur notre site.',
    url: 'https://primorixx.com/politique-cookies',
  };

  return (
    <Layout
      title="Politique de Cookies"
      description="Politique de cookies de Primorixx. Découvrez comment nous utilisons les cookies et technologies similaires sur notre site."
      canonicalUrl="/politique-cookies"
      jsonLd={jsonLd}
    >
      <div className="min-h-screen pt-20">
        <section className="py-20 bg-gradient-to-b from-dark-bg to-dark-surface">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-5xl md:text-6xl font-bold mb-6 gradient-text">
                Politique de Cookies
              </h1>
              <p className="text-lg text-dark-muted mb-8">
                Dernière mise à jour: {new Date().toLocaleDateString('fr-FR')}
              </p>

              <div className="bg-dark-card border border-dark-border rounded-xl p-8 space-y-8">
                <section>
                  <h2 className="text-2xl font-bold text-white mb-4">
                    1. Qu'est-ce qu'un Cookie?
                  </h2>
                  <p className="text-dark-muted leading-relaxed">
                    Les cookies sont de petits fichiers texte qui sont placés sur
                    votre appareil lorsque vous visitez un site. Ils sont largement
                    utilisés pour faire fonctionner les sites de manière plus
                    efficace et pour fournir des informations aux propriétaires du
                    site.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-bold text-white mb-4">
                    2. Comment Nous Utilisons les Cookies
                  </h2>
                  <p className="text-dark-muted leading-relaxed mb-4">
                    Nous utilisons des cookies à diverses fins:
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-dark-muted">
                    <li>
                      Cookies essentiels: nécessaires au fonctionnement du
                      site
                    </li>
                    <li>
                      Cookies de performance: collectent des informations sur la façon dont vous
                      utilisez le site
                    </li>
                    <li>
                      Cookies de fonctionnalité: permettent au site de se souvenir
                      de vos choix
                    </li>
                    <li>
                      Cookies marketing: utilisés pour suivre les visiteurs
                      sur différents sites
                    </li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-2xl font-bold text-white mb-4">
                    3. Types de Cookies que Nous Utilisons
                  </h2>
                  <div className="space-y-4">
                    <div>
                      <h3 className="text-xl font-semibold text-white mb-2">
                        Cookies Essentiels
                      </h3>
                      <p className="text-dark-muted leading-relaxed">
                        Ces cookies sont essentiels au fonctionnement du
                        site et ne peuvent pas être désactivés. Ils sont généralement
                        définis uniquement en réponse à vos actions.
                      </p>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-white mb-2">
                        Cookies d'Analyse
                      </h3>
                      <p className="text-dark-muted leading-relaxed">
                        Ces cookies nous permettent de compter les visites et les sources de
                        trafic pour améliorer les performances de notre site.
                      </p>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-white mb-2">
                        Cookies de Préférences
                      </h3>
                      <p className="text-dark-muted leading-relaxed">
                        Ces cookies permettent au site de se souvenir d'
                        informations qui modifient la façon dont le site se comporte
                        ou apparaît.
                      </p>
                    </div>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-bold text-white mb-4">
                    4. Cookies de Tiers
                  </h2>
                  <p className="text-dark-muted leading-relaxed">
                    Certains cookies sont placés par des services tiers qui
                    apparaissent sur nos pages. Nous ne contrôlons pas l'utilisation de ces
                    cookies et recommandons de consulter les sites des tiers
                    pour plus d'informations sur leurs cookies.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-bold text-white mb-4">
                    5. Comment Gérer les Cookies
                  </h2>
                  <p className="text-dark-muted leading-relaxed mb-4">
                    Vous pouvez contrôler et/ou supprimer les cookies comme vous le souhaitez.
                    Vous pouvez supprimer tous les cookies déjà présents sur votre ordinateur
                    et vous pouvez configurer la plupart des navigateurs pour empêcher qu'ils
                    soient placés. Cependant, si vous le faites, vous devrez peut-être
                    ajuster manuellement certaines préférences à chaque fois que
                    vous visitez un site.
                  </p>
                  <p className="text-dark-muted leading-relaxed">
                    Pour plus d'informations sur la façon de gérer les cookies, consultez l'
                    aide de votre navigateur.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-bold text-white mb-4">
                    6. Modifications de Cette Politique
                  </h2>
                  <p className="text-dark-muted leading-relaxed">
                    Nous pouvons mettre à jour cette Politique de Cookies périodiquement.
                    Nous recommandons de consulter cette page régulièrement pour
                    rester informé sur la façon dont nous utilisons les cookies.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-bold text-white mb-4">
                    7. Contact
                  </h2>
                  <p className="text-dark-muted leading-relaxed">
                    Si vous avez des questions sur l'utilisation des cookies, contactez-nous
                    par e-mail: contact@primorixx.com
                  </p>
                </section>
              </div>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default CookiePolicy;

